import Button from '@Atom/Button'
import { priceFormat } from '@Helpers/priceFormat'
import ViewPaymentProofModal from '@Molecule/ViewPaymentProofModal'
import Images from '@Theme/Images'
import moment from 'moment'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Styles from './style.module.scss'
import PaymentConfirmationModal from '@Molecule/PaymentConfirmationModal'

export default function AdminTransactionDetailsLayout() {
  const navigate = useNavigate()
  const [showProof, setShowProof] = useState(false)

  const [confirmationType, setConfirmationType] = useState('')


  const data = useMemo(() => {
    return ({
      invoiceNumber: 'INV/122023/SKILLS/00000048',
      createdAt: new Date(),
      customerName: 'Jane Jessica Doe',
      customerEmail: 'janejessica@example.com',
      customerPhoneNumber: '081920849103',
      classTitle: 'Kelas Power Pivot dan Power Query untuk Data Analis',
      price: 1450000,
      discountPercentage: '5%',
      discountRupiah: 72500,
      total: 1337500,
      transferProof: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGF9ZAa4tqerBfhwv9YQZRdaMk1e4XsMvdML3tF11-rJdOwBadZattalFbv26r3VZ9ub4&usqp=CAU'
    })
  }, [])

  // const template = useMemo(()=> {
  //   return {
  //     right: [
  //       {
  //         title: ''
  //       }
  //     ]
  //   }
  // }, [])

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <div className={Styles.back}>
          <Button
            variant='text'
            text={'Kembali'}
            startIcon={'chevron-left'}
            style={{ padding: 0 }}
            onClick={() => navigate(-1)}
          />
        </div>

        <div className={Styles.title}>
          <div className={Styles.left}>
            <span>{data?.invoiceNumber}</span>
            <span>•</span>
            <span>{moment(data?.createdAt)?.format('ll')}</span>
          </div>
          <div className={Styles.right}>
            <img alt='' src={Images.BCA_LOGO} />
            <span>•</span>
            <span>Transfer Ke Rekening BCA</span>
          </div>

        </div>
      </div>
      <div className={Styles.divider} />
      <div className={Styles.content}>
        <div className={Styles.leftCard}>
          <div className={Styles.section}>
            <h4>Detail Pembeli</h4>
            <div className={Styles.details}>
              <div className={Styles.row}>
                <p>Nama</p>
                <span>{data?.customerName}</span>
              </div>
              <div className={Styles.row}>
                <p>Email</p>
                <span>{data?.customerEmail}</span>
              </div>
              <div className={Styles.row}>
                <p>No Telp</p>
                <span>{data?.customerPhoneNumber}</span>
              </div>
            </div>
          </div>
          <div className={Styles.divider} />
          <div className={Styles.section}>
            <h4>Detail Pembelian</h4>
            <div className={Styles.details}>
              <div className={Styles.row}>
                <p>{data?.classTitle}</p>
                <span>Rp{priceFormat(data?.price)}</span>
              </div>
              <div className={Styles.row}>
                <p>Discount <span className={Styles.green}>({data?.discountPercentage})</span></p>
                <span className={Styles.red}>-Rp{priceFormat(data?.discountRupiah)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.rightCard}>
          <div className={Styles.section}>
            <h4>Rincian</h4>
            <div className={Styles.details}>
              <div className={Styles.row}>
                <p>Subtotal <span className={Styles.grey}>(1 Kelas)</span></p>
                <span>Rp{priceFormat(data?.price)}</span>
              </div>
              <div className={Styles.row}>
                <p>Discount <span className={Styles.green}>({data?.discountPercentage})</span></p>
                <span className={Styles.red}>-Rp{priceFormat(data?.discountRupiah)}</span>
              </div>

            </div>
          </div>
          <div className={Styles.divider} />
          <div className={Styles.section}>
            <div className={Styles.details}>
              <div className={Styles.row}>
                <p>Total Bayar</p>
                <span>Rp{priceFormat(data?.total)}</span>
              </div>
            </div>

          </div>
          <div className={Styles.section}>
            <h4>Bukti Pembayaran</h4>
            <div className={Styles.proof}>
              <img alt='' src={data?.transferProof} onClick={() => setShowProof(true)} />
              <span>{data?.transferProof}.jpgs</span>
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.actions}>
        <Button
          text={'Tolak Pembayaran'}
          variant='outlined-danger'
          onClick={() => setConfirmationType('negative')}
        />
        <Button
          text={'Terima Pembayaran'}
          onClick={() => setConfirmationType('positive')}
        />
      </div>
      <ViewPaymentProofModal
        show={showProof}
        setShow={setShowProof}
        proof={data?.transferProof}
      />
      <PaymentConfirmationModal
        type={confirmationType}
        onClose={() => setConfirmationType('')}
      />
    </div>
  )
}